import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-653fc016"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap fs-s"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fw-b fs-l pb-20"
}, "碳手印产品库", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "video-list learn-list d-flex"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "pt-20 pb-20 pl-20 text-gray"
}, " 正在征集中... ")])], -1));
import { ref, onMounted } from 'vue';
import ResList from '../components/ResList.vue';
import request from '@/utils/request.js';
export default {
  __name: 'ProductBase',
  setup(__props) {
    let listData = ref([]);
    function getList() {
      request({
        url: '/product_base.json',
        method: 'get'
      }).then(res => {
        listData.value = res.data;
      });
    }
    onMounted(() => {
      getList();
    });
    return (_ctx, _cache) => {
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _unref(listData).length === 0 ? (_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        class: "box-card"
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      })) : (_openBlock(), _createBlock(ResList, {
        key: 1,
        list: _unref(listData)
      }, null, 8, ["list"]))]);
    };
  }
};